// src/App.tsx - Firebase Authentication
import React from 'react';
import AppRouter from './AppRouter';
// Initialize Firebase (imported for side effects)
import './config/firebaseConfig';

function App() {
  return <AppRouter />;
}

export default App;